import Vue from 'vue'
import toLinkPhone from '../../helpers/toLink/toLinkPhone'

Vue.filter('toLinkPhone', toLinkPhone)
